import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';

export const KEY_NAME = 'cpCookiePolicySeen';

export const hasSeenCookiePolicy = () => readLocalStorage(KEY_NAME, false);

export const set = (seen = true) => writeLocalStorage(KEY_NAME, seen);
